
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brandDetails",
      function () {
        return require("private-next-pages/brandDetails/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brandDetails"])
      });
    }
  